<template id="page-top">
  <notifications position="top center" />
  <vue3-confirm-dialog></vue3-confirm-dialog>
  <div id="wrapper">
    <menuLeft v-if="!$route.meta.hideMenu" ></menuLeft>
    <div id="content-wrapper" class="d-flex flex-column">
      <div id="content">
        <menuTop v-if="!$route.meta.hideMenu"></menuTop>
        <router-view />
      </div>
      <descriptionFooter></descriptionFooter>
    </div>
    <SupportChat v-if="support == 'true'"></SupportChat>
  </div>
</template>

<script>
import menuLeft from './components/menu/menu-left.vue'
import menuTop from '@/components/menu/menu-top.vue'
import descriptionFooter from '@/components/footer/description-footer.vue'
import SupportChat from '@/components/support/support-chat.vue'

export default {
  name: 'App',
  components: { menuLeft, menuTop, descriptionFooter, SupportChat },
  data() {
    return {
      support: false,
      client_id:''
    }
  },
  mounted() {
    this.support = process.env.VUE_APP_SUPPORT
  }
}



</script>

<style></style>
